import { HandleApiError } from "sr/helpers/functions/HandleApiError";
import ApiResponse from "sr/models/ApiResponse";
import { del } from "sr/utils/axios";

export const deleteTraining = async (body) => {
    try {
  return await del<ApiResponse<[]>>(`/cleaner/training`, body).then((res)=>{
    if(res?.success===true){
        return res
    }
    else {
        return null
    }
  })
}
catch(e){
    HandleApiError(e)
}
};
